/*===========================
##########MAIN MENU##########

=====PLUGINS=====    
	#Bootstrap Input Spinner --- Documentation ---  https://shaack.com/projekte/bootstrap-input-spinner/
    	-bootstrap-input-spinner.js
        -custom-editors.js
        
=====CUSTOM JS=====        
	#Global Javascript
    	-Bootstrap Input Spinner Implementation
    #Bootstrap Tooltips
    #LazyLoad
    #Hamburger Menu Icon
    #Site Navigation
    #Cart Drawer
    #Hero
    #Product Page
    	- Variant Selection Code
	#Select Callback
    	-Variables
        -Adjust Pure Number To Money Format
        -Product Page Changes
	#FAQ Page
    #Product Recommendations
    #Variant Out Of Stock Manager
    
=====SLIDERS=====
	#Product Item Card Slider
    #Product Image Slider
    
    

===========================*/

/*###############
	#PLUGINS
###############*/

/*===============================
	#Bootstrap Input Spinner
==============================*/

/*=====bootstrap-input-spinner.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

/*=====FIXES=====*/
$(document).ready(function () {
  $(".form-control").attr("aria-label", "Quantity Input");
});

(function ($) {
  "use strict";

  // the default editor for parsing and rendering
  var I18nEditor = function (props, element) {
    var locale = props.locale || "en-US";

    this.parse = function (customFormat) {
      var numberFormat = new Intl.NumberFormat(locale);
      var thousandSeparator =
        numberFormat.format(11111).replace(/1/g, "") || ".";
      var decimalSeparator = numberFormat.format(1.1).replace(/1/g, "");
      return parseFloat(
        customFormat
          .replace(new RegExp(" ", "g"), "")
          .replace(new RegExp("\\" + thousandSeparator, "g"), "")
          .replace(new RegExp("\\" + decimalSeparator), ".")
      );
    };

    this.render = function (number) {
      var decimals = parseInt(element.getAttribute("data-decimals")) || 0;
      var digitGrouping = !(
        element.getAttribute("data-digit-grouping") === "false"
      );
      var numberFormat = new Intl.NumberFormat(locale, {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
        useGrouping: digitGrouping,
      });
      return numberFormat.format(number);
    };
  };

  var triggerKeyPressed = false;
  var originalVal = $.fn.val;
  $.fn.val = function (value) {
    if (arguments.length >= 1) {
      for (var i = 0; i < this.length; i++) {
        if (this[i]["bootstrap-input-spinner"] && this[i].setValue) {
          this[i].setValue(value);
        }
      }
    }
    return originalVal.apply(this, arguments);
  };

  $.fn.inputSpinner = function (methodOrProps) {
    if (methodOrProps === "destroy") {
      this.each(function () {
        if (this["bootstrap-input-spinner"]) {
          this.destroyInputSpinner();
        } else {
          //console.warn("element", this, "is no bootstrap-input-spinner");
        }
      });
      return this;
    }

    var props = {
      decrementButton: "<strong>&minus;</strong>", // button text
      incrementButton: "<strong>&plus;</strong>", // ..
      groupClass: "", // css class of the resulting input-group
      buttonsClass: "btn-outline-secondary",
      buttonsWidth: "2.5rem",
      textAlign: "center", // alignment of the entered number
      autoDelay: 500, // ms threshold before auto value change
      autoInterval: 50, // speed of auto value change, set to `undefined` to disable auto-change
      buttonsOnly: false, // set this `true` to disable the possibility to enter or paste the number via keyboard
      keyboardStepping: true, // set this to `false` to disallow the use of the up and down arrow keys to step
      locale: navigator.language, // the locale, per default detected automatically from the browser
      editor: I18nEditor, // the editor (parsing and rendering of the input)
      // the template of the input
      template:
        '<div class="input-group ${groupClass}">' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-decrement ${buttonsClass} btn-minus" type="button">${decrementButton}</button>' +
        '<input type="text" inputmode="decimal" style="text-align: ${textAlign}" class="form-control form-control-text-input"/>' +
        '<button style="min-width: ${buttonsWidth}" class="btn btn-increment ${buttonsClass} btn-plus" type="button">${incrementButton}</button>' +
        "</div>",
    };

    for (var option in methodOrProps) {
      // noinspection JSUnfilteredForInLoop
      props[option] = methodOrProps[option];
    }

    var html = props.template
      .replace(/\${groupClass}/g, props.groupClass)
      .replace(/\${buttonsWidth}/g, props.buttonsWidth)
      .replace(/\${buttonsClass}/g, props.buttonsClass)
      .replace(/\${decrementButton}/g, props.decrementButton)
      .replace(/\${incrementButton}/g, props.incrementButton)
      .replace(/\${textAlign}/g, props.textAlign);

    this.each(function () {
      if (this["bootstrap-input-spinner"]) {
        //console.warn("element", this, "is already a bootstrap-input-spinner");
      } else {
        var $original = $(this);
        $original[0]["bootstrap-input-spinner"] = true;
        $original.hide();
        $original[0].inputSpinnerEditor = new props.editor(props, this);

        var autoDelayHandler = null;
        var autoIntervalHandler = null;

        var $inputGroup = $(html);
        var $buttonDecrement = $inputGroup.find(".btn-decrement");
        var $buttonIncrement = $inputGroup.find(".btn-increment");
        var $input = $inputGroup.find("input");
        var $label = $("label[for='" + $original.attr("id") + "']");
        if (!$label[0]) {
          $label = $original.closest("label");
        }

        var min = null;
        var max = null;
        var step = null;

        updateAttributes();

        var value = parseFloat($original[0].value);
        var pointerState = false;

        var prefix = $original.attr("data-prefix") || "";
        var suffix = $original.attr("data-suffix") || "";

        if (prefix) {
          var prefixElement = $(
            '<span class="input-group-text">' + prefix + "</span>"
          );
          $inputGroup.find("input").before(prefixElement);
        }
        if (suffix) {
          var suffixElement = $(
            '<span class="input-group-text">' + suffix + "</span>"
          );
          $inputGroup.find("input").after(suffixElement);
        }

        $original[0].setValue = function (newValue) {
          setValue(newValue);
        };
        $original[0].destroyInputSpinner = function () {
          destroy();
        };

        var observer = new MutationObserver(function () {
          updateAttributes();
          setValue(value, true);
        });
        observer.observe($original[0], { attributes: true });

        $original.after($inputGroup);

        setValue(value);

        $input
          .on("paste input change focusout", function (event) {
            var newValue = $input[0].value;
            var focusOut = event.type === "focusout";
            newValue = $original[0].inputSpinnerEditor.parse(newValue);
            setValue(newValue, focusOut);
            dispatchEvent($original, event.type);
          })
          .on("keydown", function (event) {
            if (props.keyboardStepping) {
              if (event.which === 38) {
                // up arrow pressed
                event.preventDefault();
                if (!$buttonDecrement.prop("disabled")) {
                  stepHandling(step);
                }
              } else if (event.which === 40) {
                // down arrow pressed
                event.preventDefault();
                if (!$buttonIncrement.prop("disabled")) {
                  stepHandling(-step);
                }
              }
            }
          })
          .on("keyup", function (event) {
            // up/down arrow released
            if (
              props.keyboardStepping &&
              (event.which === 38 || event.which === 40)
            ) {
              event.preventDefault();
              resetTimer();
            }
          });

        // decrement button
        onPointerDown($buttonDecrement[0], function () {
          if (!$buttonDecrement.prop("disabled")) {
            pointerState = true;
            stepHandling(-step);
          }
        });
        // increment button
        onPointerDown($buttonIncrement[0], function () {
          if (!$buttonIncrement.prop("disabled")) {
            pointerState = true;
            stepHandling(step);
          }
        });
        onPointerUp(document.body, function () {
          if (pointerState === true) {
            resetTimer();
            dispatchEvent($original, "change");
            pointerState = false;
          }
        });
      }

      function setValue(newValue, updateInput) {
        if (updateInput === undefined) {
          updateInput = true;
        }
        if (isNaN(newValue) || newValue === "") {
          $original[0].value = "";
          if (updateInput) {
            $input[0].value = "";
          }
          value = NaN;
        } else {
          newValue = parseFloat(newValue);
          newValue = Math.min(Math.max(newValue, min), max);
          $original[0].value = newValue;
          if (updateInput) {
            $input[0].value = $original[0].inputSpinnerEditor.render(newValue);
          }
          value = newValue;
        }
      }

      function destroy() {
        $original.prop("required", $input.prop("required"));
        observer.disconnect();
        resetTimer();
        $input.off("paste input change focusout");
        $inputGroup.remove();
        $original.show();
        $original[0]["bootstrap-input-spinner"] = undefined;
        if ($label[0]) {
          $label.attr("for", $original.attr("id"));
        }
      }

      function dispatchEvent($element, type) {
        if (type) {
          setTimeout(function () {
            var event;
            if (typeof Event === "function") {
              event = new Event(type, { bubbles: true });
            } else {
              // IE
              event = document.createEvent("Event");
              event.initEvent(type, true, true);
            }
            $element[0].dispatchEvent(event);
          });
        }
      }

      function stepHandling(step) {
        calcStep(step);
        resetTimer();
        if (props.autoInterval !== undefined) {
          autoDelayHandler = setTimeout(function () {
            autoIntervalHandler = setInterval(function () {
              calcStep(step);
            }, props.autoInterval);
          }, props.autoDelay);
        }
      }

      function calcStep(step) {
        if (isNaN(value)) {
          value = 0;
        }
        setValue(Math.round(value / step) * step + step);
        dispatchEvent($original, "input");
      }

      function resetTimer() {
        clearTimeout(autoDelayHandler);
        clearTimeout(autoIntervalHandler);
      }

      function updateAttributes() {
        // copy properties from original to the new input
        if ($original.prop("required")) {
          $input.prop("required", $original.prop("required"));
          $original.removeAttr("required");
        }
        $input.prop("placeholder", $original.prop("placeholder"));
        $input.attr("inputmode", $original.attr("inputmode") || "decimal");
        var disabled = $original.prop("disabled");
        var readonly = $original.prop("readonly");
        $input.prop("disabled", disabled);
        $input.prop("readonly", readonly || props.buttonsOnly);
        $buttonIncrement.prop("disabled", disabled || readonly);
        $buttonDecrement.prop("disabled", disabled || readonly);
        if (disabled || readonly) {
          resetTimer();
        }
        var originalClass = $original.prop("class");
        var groupClass = "";
        // sizing
        if (/form-control-sm/g.test(originalClass)) {
          groupClass = "input-group-sm";
        } else if (/form-control-lg/g.test(originalClass)) {
          groupClass = "input-group-lg";
        }
        var inputClass = originalClass.replace(/form-control(-(sm|lg))?/g, "");
        $inputGroup.prop(
          "class",
          "input-group " + groupClass + " " + props.groupClass
        );
        $input.prop("class", "form-control " + inputClass);

        // update the main attributes
        min =
          isNaN($original.prop("min")) || $original.prop("min") === ""
            ? -Infinity
            : parseFloat($original.prop("min"));
        max =
          isNaN($original.prop("max")) || $original.prop("max") === ""
            ? Infinity
            : parseFloat($original.prop("max"));
        step = parseFloat($original.prop("step")) || 1;
        if ($original.attr("hidden")) {
          $inputGroup.attr("hidden", $original.attr("hidden"));
        } else {
          $inputGroup.removeAttr("hidden");
        }
        if ($original.attr("id")) {
          $input.attr("id", $original.attr("id") + "_MP_cBdLN29i2");
          if ($label[0]) {
            $label.attr("for", $input.attr("id"));
          }
        }
      }
    });

    return this;
  };

  function onPointerUp(element, callback) {
    element.addEventListener("mouseup", function (e) {
      callback(e);
    });
    element.addEventListener("touchend", function (e) {
      callback(e);
    });
    element.addEventListener("keyup", function (e) {
      if (e.keyCode === 32 || e.keyCode === 13) {
        triggerKeyPressed = false;
        callback(e);
      }
    });
  }

  function onPointerDown(element, callback) {
    element.addEventListener("mousedown", function (e) {
      if (e.button === 0) {
        e.preventDefault();
        callback(e);
      }
    });
    element.addEventListener("touchstart", function (e) {
      if (e.cancelable) {
        e.preventDefault();
      }
      callback(e);
    });
    element.addEventListener("keydown", function (e) {
      if ((e.keyCode === 32 || e.keyCode === 13) && !triggerKeyPressed) {
        triggerKeyPressed = true;
        callback(e);
      }
    });
  }
})(jQuery);

/*=====custom-editors.js=====*/

/**
 * Author and copyright: Stefan Haack (https://shaack.com)
 * Repository: https://github.com/shaack/bootstrap-input-spinner
 * License: MIT, see file 'LICENSE'
 */

var customEditors = {
  RawEditor: function (props, element) {
    this.parse = function (customFormat) {
      // parse nothing
      return customFormat;
    };
    this.render = function (number) {
      // render raw
      return number;
    };
  },
  TimeEditor: function (props, element) {
    // could be implemented more elegant maybe, but works
    this.parse = function (customFormat) {
      var trimmed = customFormat.trim();
      var sign = 1;
      if (trimmed.charAt(0) === "-") {
        sign = -1;
        trimmed = trimmed.replace("-", "");
      }
      var parts = trimmed.split(":");
      var hours = 0,
        minutes;
      if (parts[1]) {
        hours = parseInt(parts[0], 10);
        minutes = parseInt(parts[1], 10);
      } else {
        minutes = parseInt(parts[0], 10);
      }
      return (hours * 60 + minutes) * sign;
    };
    this.render = function (number) {
      var minutes = Math.abs(number % 60);
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var hours;
      if (number >= 0) {
        hours = Math.floor(number / 60);
        return hours + ":" + minutes;
      } else {
        hours = Math.ceil(number / 60);
        return "-" + Math.abs(hours) + ":" + minutes;
      }
    };
  },
};

/*=========================
	#Global Javascript
=========================*/

/*=====Bootstrap Input Spinner Implementation=====*/

$("input[type='number']").inputSpinner();

/*==========================
	#Bootstrap Tooltips
==========================*/
const tooltips = document.querySelectorAll("bootstrap-tooltip");
tooltips.forEach((t) => {
  new bootstrap.Tooltip(t);
});

/*================
	#LazyLoad
================*/
var lazyLoadInstance = new LazyLoad({
  // Your custom settings go here
});

/*===========================
	#Hamburger Menu Icon
===========================*/
const menuBtn = document.querySelector(".navbar-toggler-icon");
let menuOpen = false;
menuBtn.addEventListener("click", () => {
  if (!menuOpen) {
    menuBtn.classList.add("open");
    menuOpen = true;
  } else {
    menuBtn.classList.remove("open");
    menuOpen = false;
  }
});

/*=======================
	#Site Navigation
=======================*/
// MOBILE ADJUSTMENTS

// OPEN MOBILE NAVIGATION
$(".site-navigation-body__hamburger").on("click", function () {
  $(".body-blackout").removeClass("hidden");
  $(".site-navigation-body__menu").addClass("show");
  $("body").addClass("locked");
});

// CLOSE WHEN CLICKING X
$(".site-navigation-body__close").on("click", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("body").removeClass("locked");
  $('.qvp-slider').slick('unslick');
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  $(".body-blackout").addClass("hidden");
  $(".site-navigation-body__menu").removeClass("show");
  $("#navbarNav").removeClass("show");
  $("body").removeClass("locked");
  $('.size-guide').removeClass('active');
  $('.quickview-popup').addClass('hidden');
  
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    $(".body-blackout").addClass("hidden");
    $(".site-navigation-body__menu").removeClass("show");
    $("#navbarNav").removeClass("show");
    $("body").removeClass("locked");
  }
});

/*========================
	#LAYOUT 2 SPECIFIC
========================*/

// SEARCH FUNCTIONALITY

$(".site-navigation-body__icons--search").on("click", function () {
  $(".slideout-search-bar").toggleClass("show");
});

$(".site-navigation-body__icons--search").keypress(function (e) {
  if ( event.which == 13 ) {
    $(".slideout-search-bar").toggleClass("show");
  }
});

/*=======================
	#Cart Drawer
=======================*/
// function updateProgressBar() {
  // const includedShippingDiv = document.querySelector('.included-shipping');
  // const progressBar = document.querySelector('.included-shipping .progress-bar');
  // const shippingIncludedAmount = document.querySelector('.shipping-included-amount');
  // let freeShipAmount = parseInt(includedShippingDiv.dataset.freeShipAmount);
  // let currentCartTotal = parseInt(includedShippingDiv.dataset.total);
  // let amountLeft = (freeShipAmount - currentCartTotal) / 100;
  // const progressPercentage = ((currentCartTotal / freeShipAmount).toFixed(2) * 100);
  // progressBar.style.width = `${progressPercentage}%`;
  // progressBar.ariaValueNow = progressPercentage;
  
  // let formattedAmountLeft = (amountLeft <= 0) ? 0 : amountLeft.toLocaleString('en-US', {
  //   style: 'currency',
  //   currency: 'USD',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2     
  // });

//   if (formattedAmountLeft <= 0) {
//     document.querySelector('#free-ship-eligible .not-eligible-text').classList.add('d-none');
//     document.querySelector('#free-ship-eligible .eligible-text').classList.remove('d-none');
//   }
//   else {
//     document.querySelector('#free-ship-eligible .not-eligible-text').classList.remove('d-none');
//     document.querySelector('#free-ship-eligible .eligible-text').classList.add('d-none');
//   }
//   shippingIncludedAmount.innerHTML = formattedAmountLeft;
// }
// $(document).ready(function() {
//   updateProgressBar();
// });

var openCart = function () {
  $(".cart-drawer-body").addClass("open");
  $(".body-blackout").removeClass("hidden");
  $("body").addClass("locked");
};
var closeCart = function () {
  $(".body-blackout").addClass("hidden");
  $(".cart-drawer-body").removeClass("open");
  $("body").removeClass("locked");
};

var trashCan =
  '<svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M9 3h6v-1.75c0-.066-.026-.13-.073-.177-.047-.047-.111-.073-.177-.073h-5.5c-.066 0-.13.026-.177.073-.047.047-.073.111-.073.177v1.75zm11 1h-16v18c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-18zm-10 3.5c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm5 0c0-.276-.224-.5-.5-.5s-.5.224-.5.5v12c0 .276.224.5.5.5s.5-.224.5-.5v-12zm8-4.5v1h-2v18c0 1.105-.895 2-2 2h-14c-1.105 0-2-.895-2-2v-18h-2v-1h7v-2c0-.552.448-1 1-1h6c.552 0 1 .448 1 1v2h7z"/></svg>';
var emptyCartMessage = $(".cart-drawer-body__body").data("empty-cart-title");

// Main function that updates the cart drawer
var updateCartDrawer = function (event) {

  
  $.ajax({
    type: "get",
    url: window.Shopify.routes.root + "cart.js",
    dataType: "json",
    success: function (response) {
      // Parse cart response into json
      var cart = response;
      //console.log('update cart drawer', cart);

      const cartTotalPrice = cart.total_price;
      // document.querySelector('.included-shipping').dataset.total = cartTotalPrice;
      // updateProgressBar();

      // Set Cart Qty in icon
      var cartCount = cart.item_count;
      //desktop
      $(".announcement-bar-body__icons--cart-count").html(cartCount);
      //mobile
      $(".site-navigation-body__icons--cart-count").html(cartCount);

      var cartItems = [];
      // Add HTML of each item to the cart
      $(cart.items).each(function () {
        var vTitle = this.variant_title;
        if (vTitle == null) {
          vTitle = "";
        }
        let image = this.image.replace('.jpg', '_small.jpg');
        var item = `
          <div class="cart_item col-12 mt-3 mb-1 border-bottom pb-3" data-var-id="${this.variant_id}">
            <div class="row">
              <div class="cart_item__image col-3">
                <a href="${this.url}"><img src="${image}" alt="${this.product_title}'"></a>
              </div>
              <div class="cart_item__title col-6">
                <div class="h-100 d-flex flex-column align-items-start justify-content-between">
                  <div class="cart_item__title--product"><a href="${this.url}">${this.product_title}</a></div>`;
                  for (let option of this.options_with_values) {
                    item += `<div class=""><span class="fs-14">${option.name}: </span>${option.value}</div>`;
                  }                  
                  item += `<div class="cart_item__input">
                    <input class="form-control-sm" type="number" value="${this.quantity}">
                  </div>
                </div>
              </div>
              <div class="cart_item__delete delete col-3">
                <div class="h-100 d-flex flex-column align-items-end justify-content-between">
                  <span id="trash-icon">${trashCan}</span>
                  <div class="cart_item__price text-end mb-5">
                    <span class="fs-14">Costco Price</span>
                    <br>
                    ${Shopify.formatMoney(this.price)}
                  </div>
                </div>
              </div>
            </div>`;
        cartItems.push(item);
      });

      // Clear cart items HTML
      $(".cart-drawer-body__body .cart-item-wrapper").empty();

      for (let cartItem of cartItems) {
        $(".cart-drawer-body__body .cart-item-wrapper").append(cartItem);
      }

      // reinstantiate input spinner
      $("input[type='number']").inputSpinner();

      $(".cart-drawer-body__footer--subtotal--subtotal").html(
        "" + Shopify.formatMoney(cart.items_subtotal_price)
      );

      if (cartItems.length > 0) {
        $(".empty-cart-wrapper").addClass("d-none");
        $(".cart-drawer-body__footer").removeClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").removeClass("d-none");
      } else {
        $(".empty-cart-wrapper").removeClass("d-none");
        $(".cart-drawer-body__footer").addClass("d-none");
        $(".cart-drawer-body__body .cart-item-wrapper").addClass("d-none");
      }

      $("#cart-overlay").fadeOut();
      // Display cart
      openCart();

  let baseTotal = Shopify.formatMoney(cart.items_subtotal_price)
  let shippingThreshold =  4500   ;
  //console.log(baseTotal);
  //console.log(shippingThreshold);
    }, //Cart success function
    error: function (err) {
      console.log(err);
    },
  });
};

// OPEN CART DRAWER
$(".open-cart-drawer").on("click", function () {
  openCart();
});

$(".open-cart-drawer").keypress(function(event) {
   if (event.which == 13) {
   openCart();    
   }       
});

// CLOSE WHEN CLICKING X
$(".cart-drawer-hamburger").on("click", function () {
  closeCart();
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  closeCart();
});

// CLOSE MOBILE MENU ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    // escape key maps to keycode `27`
    closeCart();
  }
});

// CART LOADING SCREEN WHEN DELETING
$(document).on('click', '#trash-icon', function() {
  $("#cart-overlay").toggle();
  setTimeout(function() {
      $("#cart-overlay").toggle();
  }, 500); 
    // console.log('Div was clicked!');
});

// update cart when qty is changed
$(".cart-drawer-body__body").on("change", "input", function () {
  var qty = $(this).val() < 0 ? 0 : $(this).val();
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = qty;
  $("#cart-overlay").show();
  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      $("#cart-overlay").fadeOut();
    },
  });
});

// update cart when line is removed
$(".cart-drawer-body__body").on("click", ".delete svg", function () {
  var id = $(this).closest(".cart_item").data("var-id");
  var data = {};
  data.updates = {};
  data.updates[id] = 0;

  $.ajax({
    type: "post",
    url: window.Shopify.routes.root + "cart/update.js",
    data: data,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {},
  });
});

// Listen for Cart Update event
$("body").on("requestCartUpdate", updateCartDrawer);

/*============
	#Hero
============*/

/*==============
	#Footer
==============*/
$(".footer-body__menu--title-wrapper").on("click", function () {
  let connection = $(this).data("mobile-menu");

  $(".footer-body__menu--linklist." + connection).toggleClass("show");
  $(".menu-control-caret." + connection).toggleClass("show");
});

/*===== Back To Top Button =====*/

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
  scrollFunction();
};

function scrollFunction() {
  mybutton = document.getElementById("back-to-top-button");

  if(mybutton){
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      mybutton.style.display = "block";
    } else {
      mybutton.style.display = "none";
    }
  }
}  

// When the user clicks on the button, scroll to the top of the document
function topFunction() {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
}

/*=========================
	#Product Page
=========================*/
if (document.getElementById("AddToCartErr")) {
  var modal = new bootstrap.Modal(document.getElementById("AddToCartErr"));
}

// $( document ).ready(function() {
//   $('.variant-picker-body__swatch--label.label-0').click();
// });
  

/*=====VARIANT SELECTED INDICATOR*/
$(".variant-picker-body__swatch--input").on("click", function () {
  $(".variant-picker-body__swatch--input").removeClass("checked");
  $(this).addClass("checked");
});

/*=====PRODUCT TABS JS=====*/
$(".product-template__tabs--tab").on("click", function () {
  let tab = $(this).data("tab-title");
  $(".product-template__tabs--tab").removeClass("active");
  $(this).addClass("active");

  $(".product-template__tab-content--content").removeClass("active");
  $(".product-template__tab-content--content." + tab).addClass("active");
});

/*==========Add To Cart ====================*/
$("body").on("submit", "#product-form", function (e) {
  e.preventDefault();
  var form = $('form[action$="/cart/add"]').serialize();
  $("#cart-overlay").show();
  // AJAX Add To Cart
  $.ajax({
    type: "POST",
    url: window.Shopify.routes.root + "cart/add.js",
    data: form,
    dataType: "json",
    success: function (response) {
      $("body").trigger("requestCartUpdate");
    },
    error: function (err) {
      var response = JSON.parse(err.responseText);
      $("#AddToCartErr .modal-title").html(response.message);
      $("#AddToCartErr .modal-body").html(response.description);
      $("#cart-overlay").fadeOut();
      modal.show();
    },
  });
});

/*==========Variant Selection Code==========*/

// SWATCHES

jQuery(function () {
  jQuery(".swatch :radio").change(function () {
    var optionIndex = jQuery(this).closest(".swatch").attr("data-option-index");
    var optionValue = jQuery(this).val();
    jQuery(this)
      .closest("form")
      .find(".single-option-selector")
      .eq(optionIndex)
      .val(optionValue)
      .trigger("change");
  });
});

/* set initial variant options as selected */
document.addEventListener('DOMContentLoaded', () => {
  const productSelect = document.querySelector('select[name="id"]');
  if (productSelect) {
    const selectedIndex = productSelect.selectedIndex;
    if (selectedIndex !== -1) {
      const selectedOptions = productSelect.options[selectedIndex].text.split("/");
      for (let key in selectedOptions) {
        const optionValue = selectedOptions[key].trim();
        const swatchOptionInput = document.querySelector(`.swatch[data-option-index="${key}"] input[value="${optionValue}"]`);
        if (swatchOptionInput) {
          swatchOptionInput.checked = true;
          $(`.swatch[data-option-index="${key}"]`).trigger("change");
        }
      }
      
    }
  }
});



/*=======================
	#Select Callback
=======================*/

var selectCallback = function (variant, selector) {
  //console.log('CallBack');
  //   VARIABLES
  var costcoPrice = Shopify.formatMoney(variant.price);
  var regularPrice = Shopify.formatMoney(variant.compare_at_price);

  // PRODUCT PAGE CHANGES
  $(".product-template__body--price .costco-price span").html(costcoPrice);
  $(".product-template__body--price .regular-price span").html(regularPrice);

  //   PRODUCT IMAGE SLIDER FILTERING

  $(".product-image-slider__body").slick("slickUnfilter");
  $(".product-image-slider__thumbnails").slick("slickUnfilter");

  $(".slick-filter-image").removeClass("filter");

  if (variant) {
    var filterIndexes = [];
    $(".swatch").each(function (index, item) {
      var optionName = $(item).data("option-name").toLowerCase();
      if (optionName == "size" || optionName == "color") {
        if($(this).data("file-alt") && optionName == 'size'){
          //Using Metafields ignoring size (Put in Place for Dearfoams and Baggalinni )
        }else{
          filterIndexes.push(index + 1);
        }
        
        if (optionName == "color") {
          var color = variant["option" + (index + 1)];
          if ($(item).find(".shown-in").length > 0) {
            $(item).find(".shown-in").html('<b>Selected Style:</b> ' +color);
          } else {
            $(item).prepend(
              '<span class="shown-in pe-2"><b>Selected Style:</b> ' + color + "</span>" );
          }
        }
        //CNX JPD - Removed Selected Size verbage
        /*if (optionName == "size") {
          var color = variant["option" + (index + 1)];
          if ($(item).find(".shown-in").length > 0) {
            $(item).find(".shown-in").html('<b>Selected Size:</b> ' + color+'<span class="show-size-guide">Size & Fit Guide</span>');
          } else {
            //".variant-picker-body__swatch"
            $(item).prepend(
              '<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' +
                color +
                '<span class="show-size-guide">Size & Fit Guide</span></span>'
            );
          }
        } */
      }
    });
    var fileName = "";
    //console.log(filterIndexes)
    if (filterIndexes.length > 0) {
      $(filterIndexes).each(function (index, item) {
        var option = "option" + item;
        //console.log(option)
        //console.log(variant[option])
        if (index != 0) {
          fileName += "-";
        }
        fileName += variant[option].replace(/\s/g, "-").replace("#", "").replace(/"/g,"").replace(/\//g, "-");
      });
    }


    
    fileName = fileName.toLowerCase();
    $(".slick-filter-image").each(function () {
      if($(this).data("file-alt")){
        var dataFile = $(this).data("file-alt").toLowerCase().replace(/\s/g, "-").replace("#", "").replace(/"/g,"").replace(/\//g, "-");
       //console.log('With Alt')
      }else{
        var dataFile = $(this).data("file-name").toLowerCase();
        //console.log('Without Alt')
      }



      
      if (dataFile.indexOf(fileName) > -1) {
        $(this).addClass("filter").addClass('lft-filter');
      //console.log(fileName)
      //console.log(dataFile)
      //console.log('Index Lookup-'+dataFile.indexOf(fileName))
      }
    });

    if ($(".filter").length > 0) {
      $(".product-image-slider__body").slick("slickFilter", ".filter");
      $(".product-image-slider__thumbnails").slick("slickFilter", ".filter");

      // re index thumbnail slides
      $(".product-image-slider__thumbnails .slick-slide").each(function (
        index
      ) {
        var originalIndex = $(this).data('originalIndex');        
        $(this).attr("data-slick-index", index);
        if(originalIndex != 'empty'){
          $(this).attr("data-originalIndex", originalIndex);
        }        
      });
      // re index main slides
      $(".product-image-slider__body .slick-slide").each(function (index) {
        var originalIndex = $(this).data('originalIndex');
        $(this).attr("data-slick-index", index);
        if(originalIndex != 'empty'){
          $(this).attr("data-originalIndex", originalIndex);
        }
      });
      
      $(".product-image-slider__thumbnails").slick("slickGoTo", 0);

      if ($(".product-image-slider__thumbnails .slick-track").length < 6) {
        $(".product-image-slider__thumbnails .slick-track")
          .css("transform", "none !important")
          .css("width", "100% !important")
          .css("margin", "0 !important;");
      }
    }
  } //   END IF VARIANT

  //  UPDATE VARIANT SPECIFIC CONTENT

  function decodeEntity(inputStr) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = inputStr;
    return textarea.value;
  }
  if (Object.keys(vmeta[variant.id]).length > 0) {
    for (let i = 1; i < 5; i++) {
      var tabs = Array.from(vmeta[variant.id]);

      $(".product-template__tab-content--content.tab" + i).html(
        decodeEntity(vmeta[variant.id]["tab" + i])
      );
    }
  }
}; // END OF SELECT CALLBACK

/*================
	#FAQ PAGE
================*/

$(".faq-page__question--title").on("click", function () {
  $(this).toggleClass("active");
  $(this).siblings().closest(".faq-page__answer").toggleClass("active");
});

/*===============================
	#Product Recommendations
===============================*/

const handleIntersection = (entries, observer) => {
  if (!entries[0].isIntersecting) return;

  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  observer.unobserve(productRecommendationsSection);

  const url = productRecommendationsSection.dataset.url;

  fetch(url)
    .then((response) => response.text())
    .then((text) => {
      const html = document.createElement("div");
      html.innerHTML = text;
      const recommendations = html.querySelector(".product-recommendations");

      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
      $(".product-recommendations-slider").slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 769,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              arrows: true,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
              arrows: false,
              centerMode: true,
              dots: true,
            },
          },
        ],
      });
    })
    .catch((e) => {
      console.error(e);
    });
};
if ($(".product-recommendations").length > 0) {
  const productRecommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  const observer = new IntersectionObserver(handleIntersection, {
    rootMargin: "0px 0px 200px 0px",
  });

  observer.observe(productRecommendationsSection);
}

/*====================================
	#Variant Out Of Stock Manager
====================================*/

var Shopify = Shopify || {};

Shopify.optionsMap = {};

Shopify.updateOptionsInSelector = function (selectorIndex) {
  switch (selectorIndex) {
    case 0:
      var key = "root";
      var selector = jQuery(".swatch:eq(0) :checked");
      break;
    case 1:
      var key = jQuery(".swatch:eq(0) input:checked").val();

      var selector = jQuery(".swatch:eq(1) :checked");
      break;
    case 2:
      var key = jQuery(".swatch:eq(0) :checked").val();
      key += " / " + jQuery(".swatch:eq(1) :checked").val();
      var selector = jQuery(".swatch:eq(2) :checked");
  }
  var initialValue = selector.val();

  var availableOptions = Shopify.optionsMap[key];
  jQuery('.swatch[data-option-index="' + selectorIndex + '"] input').each(
    function () {
      if (jQuery.inArray($(this).val(), availableOptions) !== -1) {
        $(this)
          .removeClass("soldout")
          .removeAttr("disabled", "disabled")
          .removeAttr("checked");
      } else {
        $(this)
          .addClass("soldout")
          .removeAttr("checked")
          .attr("disabled", "disabled");
      }
    }
  );
  if (jQuery.inArray(initialValue, availableOptions) !== -1) {
    selector.attr("checked");
  }
};

Shopify.linkOptionSelectors = function (product) {
  // Building our mapping object.
  for (var i = 0; i < product.variants.length; i++) {
    var variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      Shopify.optionsMap["root"] = Shopify.optionsMap["root"] || [];
      Shopify.optionsMap["root"].push(variant.option1);
      Shopify.optionsMap["root"] = Shopify.uniq(Shopify.optionsMap["root"]);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        var key = variant.option1;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option2);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        var key = variant.option1 + " / " + variant.option2;
        Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
        Shopify.optionsMap[key].push(variant.option3);
        Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  Shopify.updateOptionsInSelector(0);
  if (product.options.length > 1) Shopify.updateOptionsInSelector(1);
  if (product.options.length === 3) Shopify.updateOptionsInSelector(2);

  // When there is an update in the first dropdown.
  jQuery(".swatch:eq(0)").change(function () {
    Shopify.updateOptionsInSelector(1);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });

  // When there is an update in the second dropdown.
  jQuery(".swatch:eq(1)").change(function () {
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2);
    return true;
  });
};

var $addToCartForm = $('form[action="/cart/add"]');
if (window.MutationObserver && $addToCartForm.length) {
  if (
    typeof observer === "object" &&
    typeof observer.disconnect === "function"
  ) {
    observer.disconnect();
  }
  var config = { childList: true, subtree: true };
  var observer = new MutationObserver(function () {
    Shopify.linkOptionSelectors(productObj);
    observer.disconnect();
  });
  observer.observe($addToCartForm[0], config);
}

/*###############
	#SLIDERS
###############*/

$(document).ready(function () {}); // Document Ready Function End
/*================================
	#Hero Slider
================================*/

$(".hero-body-slidshow").slick({
  dots: true,
});

/*================================
	#Product Item Card Slider
================================*/

$(".product-item-card-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        arrows: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        arrows: false,
        centerMode: false,
        dots: false,
      },
    },
  ],
});

$(window).on('load', function() {
  //console.log('Slider Ready');
  $(".product-item-card-option-slider").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    cssEase: false,
    arrows: true
  });
});

/*============================
  #Five Grid Alpha Slider
============================*/


$(".fivegridalpha-slider").slick({
  infinite: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 3.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    }
  ],
});



/*=================================
  #HP Featured Products Slider
=================================*/

$(".hp-featured-products-slider").slick({
  infinite: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 2.5,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
      },
    },
    {
      breakpoint: 769,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        arrows: false,
        centerMode: false,
        dots:false,
      },
    }
  ],
});

/*============================
	#Product Image Slider
============================*/
$(".product-image-slider__body").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: false,
  fade: true,
  asNavFor: ".product-image-slider__thumbnails",
});

$(".product-image-slider__thumbnails").slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  asNavFor: ".product-image-slider__body",
  dots: false,
  centerMode: false,
  focusOnSelect: true,
  infinite: false,
  arrows: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
  ],
});

/*=====================
  #Lightbox Slider
=====================*/
var zoomSlider
$('.zslidertrigger, .slider-zoom-icon, .jpd').on('click', function () { 
  console.log('Init')
  var activeSlide =$(this).closest('.product-image-slider').find('.product-image-slider__body .slick-active')[0];
  var slideIndex = $(activeSlide).data('slick-index');
  $('.zslider-blackout').removeClass('hidden');
  $('body').addClass('locked');
  window.scrollTo(0, 0);
  if( ! zoomSlider){
    zoomSlider = $('.zoom-image-slider__body').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      infinite:false,                
      speed:0,
      responsive:[
        {
          breakpoint:769,
          settings:{
  
          }
        }
      ]
    });
  }

    var filterIndexes = [];
    $(".swatch").each(function (index, item) {
      var optionName = $(item).data("option-name").toLowerCase();
      console.log(optionName);
      if (optionName == "size" || optionName == "color") {
        if($(this).data("file-alt") != 'undefined' && optionName == 'size'){
          //Using Metafields ignoring size (Put in Place for Dearfoams and Baggalinni )
        }else{
        filterIndexes.push(index + 1);
        }
      }
    });
    var fileName = "";

    if (filterIndexes.length > 0) {
      $(filterIndexes).each(function (index, item) {
        var option = "option" + item;
        if (index != 0) {
          fileName += "-";
        }
        var vName = $('.product-form__input[data-option-index="'+(item-1)+'"] input:checked');
        vNameFinal = vName[0].defaultValue
        
        fileName += vNameFinal.replace(/\s/g, "-").replace("#", "").replace(/"/g,"").replace(/\//g, "-");
      });
    }


    
    fileName = fileName.toLowerCase();
    $(".zslick-filter-image").each(function () {
    if($(this).data("file-alt") != 'undefined'){
        var dataFile = $(this).data("file-alt").toString().toLowerCase().replace(/\s/g, "-").replace("#", "").replace(/"/g,"").replace(/\//g, "-");
      }else{
        var dataFile = $(this).data("file-name").toString().toLowerCase();
      }

      if (dataFile.indexOf(fileName) > -1) {

        $(this).addClass("filter");
      }

    });
    if ($(".filter").length > 0) {
      zoomSlider.slick("slickFilter", ".filter");

      // re index main slides
      $(".zoom-image-slider__body .slick-slide").each(function (index) {
        $(this).attr("data-slick-index", index);
      });
      
    }
  console.log(zoomSlider.slick('slickCurrentSlide'));
  
  console.log('slickGoTo: '+slideIndex);
  zoomSlider.slick('slickGoTo', slideIndex);
  
  console.log(zoomSlider.slick('slickCurrentSlide'));

});

$('.close-zoom').on('click', function () { 
  $('.zslider-blackout').addClass('hidden');

  $('body').removeClass('locked');
  zoomSlider.slick("slickUnfilter");
  console.log('Unfilter')
});

/* workaround for size option disabled on page load */
$(document).ready(function () {
  triggerPickerSelect();
});
function triggerPickerSelect() {
  const colorPicker = $('input[name="Color"].checked');
  const sizePicker = $('input[name="Size"].checked');
  if (colorPicker.length > 0) {
    colorPicker.trigger('click');
  }
  if (sizePicker.length > 0) {
    setTimeout(() => {
      sizePicker.trigger('click');
    }, 10);
  }
}

/*================
  #Size Guide
===============*/
$('body').on('click', '.show-size-guide', function(){
  $('.size-guide').addClass('active');
  $('body').addClass('locked')
  $('.body-blackout').removeClass('hidden');
});

$('body').on('click', '.size-guide-close', function(){
  $('.size-guide').removeClass('active');
  $('body').removeClass('locked');  
  $('.body-blackout').addClass('hidden');
});


/*===============
  #Quickview
==============*/


$('body').on('click', '.quickview', function(){
  console.log('Quickview Clicked');
    
//Slider
  //$('.qvp-slider').html('');//Clear Product Images on Quickview
    $('.quickview-popup .product-details').html('');  
    $.get( $(this).data('link'), function( data ) {
      var productInfo = $(data).find('.product-template__body')[0];
      var inputs = $(productInfo).find('variant-radios input')
      var labels = $(productInfo).find('variant-radios label')
      console.log(inputs.length+ '-'+labels.length)
      $(labels).each(function(index,item){
        var qvinput = 'qv'+$(this).attr('for');
        $(this).attr('for', qvinput)
      })
      $(inputs).each(function(index,item){
        var qvinput = 'qv'+$(this).attr('id');
        $(this).attr('id', qvinput)
      })
      $('.quickview-popup .product-details').html(productInfo);
      var colorText = $.parseHTML('<span class="shown-in pe-2"><b>Selected Style:</b> ' + $('input[name="Color"]')[0].value + '</span>')
      var sizeText = $.parseHTML('<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' +  $('input[name="Size"]')[0].value + '</span>')

      $('.quickview-popup input[name="Color"]')[0].closest('fieldset').prepend(colorText[0]);
      $('.quickview-popup input[name="Size"]')[0].closest('fieldset').prepend(sizeText[0]);
      $('.quickview-popup .product-image-slider__body').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        fade: true,
        asNavFor: ".quickview-popup .product-image-slider__thumbnails"
      });
      $('.quickview-popup .product-image-slider__thumbnails').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        asNavFor: ".quickview-popup .product-image-slider__body",
      });
      $(".quickview-popup input[type='number']").inputSpinner();

      $(".quickview-popup").on("change",".swatch :radio", function () {
        var optionIndex = $(this).closest(".swatch").attr("data-option-index");
        var optionValue = $(this).val();
        var SetVal = '';

        if($(this).attr('name') == "Color") {
          var color = optionValue;
          if ($(this).closest('fieldset').find(".shown-in").length > 0) {
            $(this).closest('fieldset').find(".shown-in").html('<b>Selected Style:</b> ' +color);
          } else {
            $(this).closest('fieldset').prepend(
              '<span class="shown-in pe-2"><b>Selected Style:</b> ' + color + "</span>" );
          }
        }
        if($(this).attr('name') == "Size") {
          var size = optionValue;
          if ($(this).closest('fieldset').find(".shown-in").length > 0) {
            $(this).closest('fieldset').find(".shown-in").html('<b>Selected Size:</b> ' + size);
          } else {
            $(this).closest('fieldset').prepend(
              '<span class="shown-in pe-2 pb-3 d-block"><b>Selected Size:</b> ' +
                size +
                "</span>"
            );
          }
        }
        
        $(".quickview-popup input.variant-picker-body__swatch--input").each(function(index,item){
          console.log(item)
          if ($(item).is(':checked')){
            if (SetVal != '') { SetVal += ' / ';}
            SetVal += $(this).val();
          }
        })
        $('.quickview-popup #product-select option').each(function(index,option){
          if ($(option).html().trim() == SetVal) {
            $(option).prop('selected', true);
            $('#product-select').val(parseInt($(option).val())).trigger("change");
          }
        })
        if($(this).attr('name') == 'Color') {
          $('.quickview-popup .product-image-slider__thumbnails').slick("slickUnfilter");
          $('.quickview-popup .product-image-slider__body').slick("slickUnfilter");
          $('.quickview-popup .slick-filter-image').removeClass('filter');
          $('.quickview-popup .slick-filter-image').each(function(){
            if($(this).data('alt') == optionValue) {
              $(this).addClass('filter');
            }
          });
          if($('.quickview-popup .slick-filter-image.filter').length > 0) {
            $('.quickview-popup .product-image-slider__thumbnails').slick("slickFilter", ".filter");
            $('.quickview-popup .product-image-slider__body').slick("slickFilter", ".filter");
          }
        }
      });
  });
  
  
//   setTimeout(function(){
//     $(".qvp-slider").slick({
//       slidesToShow: 1,
//       slidesToScroll: 1,
//       arrows: true,
//       infinite: false,
//       fade: true
//     });
//   }, 100);

  
  
//   let pTitle = $(this).data('title');
//   let pPrice = $(this).data('price');
//   let pCompare = $(this).data('compare');
   let pLink = $(this).data('link');
//   let pId = $(this).data('id');
//   let pImages = $(this).data('images').split(',');
//   let pImage = pImages[0];
//   let pOptions = $(this).data('options').toLowerCase().split(',');
//   let pValuesSize = $(this).data('valuessize').split(',');
//   let pValuesColor = $(this).data('valuescolor').split(',');
//   let pVariantImage = $(this).data('variantimage').split(',');
    
  
  $('.quickview-popup').removeClass('hidden');
  $(".body-blackout").removeClass("hidden");
  $("body").addClass("locked");

  
//   $('.quickview-popup .qvp-title').html(pTitle); //Product Title on Quickview
   $('.quickview-popup .qvp-link').attr('href', pLink) //Product Link on Quickview
//   $('.quickview-popup .qvp-id').attr('value', pId) //Product Id on Quickview
//   $('.quickview-popup .qvp-image').attr('src', pImage) //Initial Product Image on Quickview

// //Quick View Options
//   $.each(pOptions, function(i){
//     $('.qvp-options').append(`<div class="qvp-${pOptions[i]} option-${pOptions[i]}" style="padding-top:10px;"><div class="" style="padding-bottom:25px;"><b>Selected ${pOptions[i]}:</b></div></div>`);//Product Options on Quickview
//   });  

// // Quick View Size Values
//   $.each(pValuesSize, function(i){
//     $('.qvp-size').append(`<div class="variant-picker-body__swatch--label" style="">${pValuesSize[i]}</div>`);//Product Value of Size on Quickview
//   }); 

// // Quick View Color Values
//   $.each(pValuesColor, function(i){
//     $('.qvp-color').append(`<div class="variant-picker-body__swatch--label" style="border-radius: 12px; max-width: unset; display: inline;padding: 10px;"><img src="${pValuesColor[i]}" alt=""></div>`);//Product Value of Color on Quickview
//   }); 

  
  
//   //Quick View Images
//   $.each(pImages, function(i){
//     console.log(pImages[i]);
//     $('.qvp-slider').append(`<div class=""><img src="${pImages[i]}" alt="QuickView Image" style="float:left;"></div>`);//Product Images on Quickview
//   });  
  
  
//   if(pCompare != ''){
//     $('.quickview-popup .qvpprice').html(`Promo Price<br><span class="">${pPrice}</span>`); //Product Price on Quickview with promo
//     $('.quickview-popup .qvcprice').html(`Costco Price<br><span class=""><s>${pCompare}</s></span>`); //Product Compare At Price on Quickview
//   }else{
//     $('.quickview-popup .qvpprice').html(`Costco Price<br><span class="">${pPrice}</span>`); //Product Price on Quickview
//   }
});


$('body').on('click', '.close-icon', function(){
  console.log('Clicked Close')
  $('.quickview-popup').addClass('hidden');
  $(".body-blackout").addClass("hidden");
  $("body").removeClass("locked");
  $('.quickview-popup .qvpprice').html('');
  $('.quickview-popup .qvcprice').html('');
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
});

// CLOSE ON CLICK OF BLACKOUT AREA
$("body").on("click", ".body-blackout", function () {
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
});

// CLOSE QUICKVIEW ON HITTING ESCAPE
$(document).keyup(function (e) {
  if (e.keyCode == 27) {
    //$('.qvp-slider').slick('unslick');
    $('.qvp-slider').html('');//Clear Product Images on Quickview
    $('.quickview-popup').addClass('hidden');
  }
});

//CLOSE QUICKVIEW ON HITTING ATC

$('body').on('click', '.product-atc', function(){
  //$('.qvp-slider').slick('unslick');
  $('.qvp-slider').html('');//Clear Product Images on Quickview
  $('.quickview-popup').addClass('hidden');
});




/*========================
  #Filter Adjustments
=======================*/
$('.open-close-caret').on('click', function(){
  console.log('Testing');
});

$('.collection-filters li').on('click', function(){
  $(this).closest('#filter-form').submit();
});

$('.price-checkbox').on('click', function(){
  let minPrice = $(this).data('min')
  let maxPrice = $(this).data('max')

  $('.min-input').val(minPrice)
  $('.max-input').val(maxPrice)
});

$('.mobile-filter-trigger').on('click', function(){
  $('.collection-filter-wrapper').toggleClass('active');
  $('.collection-grid-blackout').toggleClass('active');
  // $('body').toggleClass('locked');
});

$('.filter-close').on('click', function(){
  $('.collection-filter-wrapper').removeClass('active');
  $('.collection-grid-blackout').removeClass('active');
  $('body').removeClass('locked');
});

$('.collection-grid-blackout').on('click', function(){
  $('.collection-filter-wrapper').removeClass('active');
  $('.collection-grid-blackout').removeClass('active');
  $('body').removeClass('locked');
}); 

/////////////////////////////////////////
// Makes external links open in new tab
const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}
///////////////////////////////////////////